export default __webpack_public_path__ + "static/Paul_Mensink_1-ebce1b0d7b1811a6e954bf6ccc6fc590.jpg";